<style lang="less" rel="stylesheet/less" scoped>
    .question-page{
        min-height:100%;
        background:#ECEFF1;
    }
    .question-header{
        padding:15px 15px 0 15px;
        h2{
            font-size:18px;
            font-weight:bold;
            color:#333;
            line-height:1em;
            margin-bottom:10px;
        }
        .progress{
            height:7px;
            background:#fff;
            border-radius:5px;
            overflow:hidden;
            box-shadow:0px 1px 8px 0px rgba(51,51,51,0.06);
            margin-bottom:20px;
            .progress-bar{
                height:100%;
                background:#23E3C6 linear-gradient(90deg,#176FD7,#23E3C6,#18DC76);
                border-radius:5px;

            }
        }
    }
    .question-body{
        margin:0 15px;
    }
    .question-footer{
        margin-top:40px;
        text-align:center;
        padding-bottom:100px;
        .next-question{
            position:relative;
            display:inline-block;
            margin:0 5px;
            width:58px;
            height:58px;
            background:linear-gradient(135deg,rgba(138,239,5,0.9),rgba(0,227,128,0.9));
            border-radius:18px;
            &:before{
                content:'';
                display:block;
                height:5px;
                width:22px;
                background: #fff;
                position:absolute;
                border-radius:5px;
                top:50%;
                left:50%;
                transform:translateX(-50%) translateY(-50%);

            }
            &:after{
                content:'';
                display:block;
                height:0;
                width:0;
                border-style:solid;
                border-width:8px 0 8px 8px;
                border-color:transparent #fff;
                position:absolute;
                top:50%;
                left:50%;
                transform: translateX(5px) translateY(-50%);
            }
            &.prev{
                &:after{
                    border-width:8px 8px 8px 0;
                    left:auto;
                    right:50%;
                    transform: translateX(-5px) translateY(-50%);
                }
            }
        }
    }
</style>
<template>
    <div class="question-page" :style="{minHeight:minHeight+'px'}">
        <div class="question-header">
            <h2>#{{currentIndex+1}}/{{questionList.length}}</h2>
            <div class="progress">
                <div class="progress-bar" :style="{width:getPercent((currentIndex+1),questionList.length)}"></div>
            </div>
        </div>
        <div class="question-body">
            <QuestionItem ref="questionItem" :item="getCurrentQuestion()"></QuestionItem>
        </div>
        <div class="question-footer">
            <div class="next-question prev" @click="goPrev()" v-if="hasHistory()"></div>
            <div class="next-question" @click="goNext()"></div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import api from '../lib/api';
    import Store from '../lib/store';
    import event from '../lib/event';
    import QuestionItem from '../components/QuestionItem.vue';
    import {QUESTION_TYPE} from '../lib/const';

    export default {
        data() {
            return {
                data:null,
                questionList:[],
                history:[],
                currentIndex:0
            }
        },
        computed: {
            minHeight(){
                return Store.state.minHeight;
            }
        },
        methods: {
            async init(){
                let sid = this.$route.query.sid;
                let data = await api.getSurveyDetail(sid);
                this.questionList = this.preProcessList(data.question_list);
                this.data = data;
                this.recordHistory(this.currentIndex);
            },
            getPercent(a,b){
                if(b.toString()==='0'){
                    return '0%';
                }else{
                    return (a/b)*100 + '%';
                }
            },
            preProcessList(list){
                list.forEach(a=>{
                    a.answer = "";
                    if(a.subquest_list){
                        a.subquest_list.forEach(b=>{
                            b.answer = "";
                            a.subquest_list = a.subquest_list || null;
                        })
                    }else{
                        a.subquest_list = null;
                    }
                })
                return list;
            },
            getCurrentQuestion(idx){
                return this.questionList[idx||this.currentIndex];
            },
            recordHistory(n){
                this.history.push(n);
            },
            popHistory(){
                this.history.pop();
                return this.history[this.history.length-1];
            },
            hasHistory(){
                return this.history.length>1;
            },
            goToIndex(n){
                this.currentIndex = n;
                this.recordHistory(this.currentIndex);
            },
            checkValid(){
                return this.$refs.questionItem.checkValid();
            },
            goNext(){
                if(!this.checkValid())return;
                let q = this.getCurrentQuestion();
                if(this.getCurrentQuestion(this.currentIndex+1)){
                    this.goToIndex(this.currentIndex+1);
                }else{
                    this.onFinish();
                }
            },
            getAnswerList(){
                // let map = {};
                // this.questionList.forEach(a=>{
                //
                //     if(a.subquest_list){
                //         a.subquest_list.forEach(b=>{
                //             map[b.id] = b.answer;
                //         })
                //     }else{
                //         map[a.id] = a.answer;
                //     }
                // })
                // return map;
                let arr = [];
                this.questionList.forEach(a=>{

                    if(a.subquest_list){
                        a.subquest_list.forEach(a=>{
                            arr.push({
                                qid:a.id,
                                answer:a.type===QUESTION_TYPE.MULTI_SELECT ? a.answer.split('|') : a.answer
                            })
                        })
                    }else{
                        arr.push({
                            qid:a.id,
                            answer:a.type===QUESTION_TYPE.MULTI_SELECT ? a.answer.split('|') : a.answer
                        })
                    }
                })
                return arr;
            },
            onFinish(){
                let answers = this.getAnswerList();

                api.submitSurvey(this.data.sid,answers).then(res=>{
                    event.emit('toast','提交成功');
                    if(res.id){
                        $router.go({name:'survey-result-detail',query:{id:res.id}});
                    }
                });
            },
            goPrev(){
                this.currentIndex = this.popHistory();
            }
        },
        components: {QuestionItem},
        mounted() {
            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// survey-detail.vue?1cb93891